import { graphql } from "@/gql";

export const ORGANIZTIONS_FRAGMENT = graphql(`
  fragment ORGANIZTIONS_FRAGMENT on Organization {
    id
    name
    logoUrl
    createdAt
    state
    plan {
      id
      name
    }
  }
`);

export const ORGANIZATIONS_QUERY = graphql(`
  query organizations {
    adminOrganizations(includeDeleted: true) {
      edges {
        node {
          id
          name
          createdAt
          state
          plan {
            id
            name
          }
          ...ORGANIZTIONS_FRAGMENT
        }
      }
    }
  }
`);
